<template>
  <admin-card title="Редактирование данных пользователя">
    <form @submit.prevent="update" @keydown="form.onKeydown($event)">
      <!-- User Name -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Имя</label>
        <div class="col-md-7">
          <input v-model="form.name" type="text" name="name" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('name') }">
          <has-error :form="form" field="name"></has-error>
        </div>
      </div>

      <!-- User email -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Email</label>
        <div class="col-md-7">
          <input v-model="form.email" type="email" name="email" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('email') }">
          <has-error :form="form" field="email"></has-error>
        </div>
      </div>

      <!-- User phone -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Телефон</label>
        <div class="col-md-7">
          <input v-model="form.phone" type="text" name="phone" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('phone') }">
          <has-error :form="form" field="phone"></has-error>
        </div>
      </div>

      <!-- User country -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Страна</label>
        <div class="col-md-7">
          <input v-model="form.country" type="text" name="country" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('country') }">
          <has-error :form="form" field="country"></has-error>
        </div>
      </div>

      <!-- User city -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Город</label>
        <div class="col-md-7">
          <input v-model="form.city" type="text" name="city" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('city') }">
          <has-error :form="form" field="city"></has-error>
        </div>
      </div>

      <!-- User specialization -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Специализация</label>
        <div class="col-md-7">
          <input v-model="form.specialization" type="text" name="specialization" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('specialization') }">
          <has-error :form="form" field="specialization"></has-error>
        </div>
      </div>

      <!-- User organization -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Организация</label>
        <div class="col-md-7">
          <input v-model="form.organization" type="text" name="organization" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('organization') }">
          <has-error :form="form" field="organization"></has-error>
        </div>
      </div>

      <!-- User password -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Пароль</label>
        <div class="col-md-7">
          <input v-model="form.password" type="text" name="password" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('password') }">
          <has-error :form="form" field="password"></has-error>
        </div>
      </div>

      <!-- User Roles -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Роли пользователя</label>
        <div class="col-md-7">
          <div class="form-check" v-for="role in roles">
            <label class="form-check-label">
              <input type="checkbox"
                     v-model="form.roles"
                     :class="{ 'is-invalid': form.errors.has('roles') }"
                     class="form-check-input"
                     :value="role.slug"
                     name="hidden">
              {{ role.name }}
            </label>
            <has-error :form="form" field="roles"></has-error>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-group row">
        <div class="col-md-9 ml-md-auto">
          <v-button type="success" :loading="form.busy">Сохранить</v-button>
        </div>
      </div>
    </form>
  </admin-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { Form } from 'vform';
  import AdminPage from '../admin-page';

  export default {
    metaInfo () {
      return { title: 'Редактирование пользовательской информации' }
    },
    extends: AdminPage,
    computed: mapGetters({
      roles: 'roles/roles',
      user: 'users/user'
    }),
    data: () => ({
      form: new Form({
        id: 0,
        name: '',
        email: '',
        phone: '',
        photo_url: '',
        country: '',
        city: '',
        specialization: '',
        organization: '',
        password: '',
        roles: [],
      })
    }),
    methods: {
      async update () {
        this.$store.dispatch('users/update', this.form);
        this.$alertify.success(this.$t('admin.global.labels.alert-success'));
      }
    },
    beforeMount () {
      const userId = parseInt(this.$route.params.id);

      this.$store.dispatch('users/find', userId)
        .then(e => {
          this.form.keys().forEach(key => {
            console.log(key, this.user[key]);
            this.form[key] = this.user[key]
          });
        });

      this.$store.dispatch('roles/fetchRoles');
    }
  }
</script>
